import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';

@Injectable({ providedIn: 'root' })

export class PurchaseOrderImportFileService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr/backoffice-ep';
  download_sample_path: string;


  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr/backoffice-ep';
    this.download_sample_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr';
    this.httpClient = http;
  }

  public uploadImportFile(formData: FormData, fileType: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/' + fileType;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  async downloadSampleCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
        .get(CSV_URL, { headers, responseType: 'blob' })
        .toPromise();
    return fileBlob;
}

}
